import { render, staticRenderFns } from "./LoyaltyRewardBanner.vue?vue&type=template&id=4ef060a9&scoped=true"
import script from "./LoyaltyRewardBanner.vue?vue&type=script&lang=js"
export * from "./LoyaltyRewardBanner.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyRewardBanner.vue?vue&type=style&index=0&id=4ef060a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef060a9",
  null
  
)

export default component.exports